export default {
  setCancellationReviewsLoading(state, payload) {
    state.cancellationReviewsLoading = payload;
  },
  setCancellationReviews(state, payload) {
    state.cancellationReviews = payload;
  },
  setTotalCancellationReviews(state, total) {
    state.totalCancellationReviews = parseInt(total, 10);
  },
};
